module.exports = __webpack_public_path__ + "static/img/thuphan.8b52d18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/homepage/thuphan.png
// module id = CmUQ
// module chunks = 2